<n-slide-window *ngIf="pageReady"
    [(visible)]="windowVisible"
    [width]="SWITCH.IS_SIMPLE_MODE ? '8.96rem' : '8rem'"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.createTitle}}</h1>
        <n-help-link key="authenticationwindowsuserCreate" *ngIf="!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifywindowsCreate" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>

    <form [ngClass]="{ 'form-width-simple': SWITCH.IS_SIMPLE_MODE, 'common-form': !SWITCH.IS_SIMPLE_MODE }"
        [formGroup]="vm"
        [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [errorMessage]="errorMessage">
        <n-form-item [label]="i18n.vstoreLab" *ngIf="!SWITCH.IS_SIMPLE_MODE"
            [required]="!vstore || !vstore.value">
            <n-select *ngIf="!vstore || !vstore.value"
                #vstoreSelect
                id="create-windows-local-access-user-vstore"
                formControlName="vstoreId"
                [rest]="vstoreRest"
                [filter]="true"
                [labelField]="'NAME'"
                [valueField]="'ID'"
                (onChange)="onVstoreChange($event)">
            </n-select>
            <div class="n-form-item-text" *ngIf="vstore && vstore.value">{{vstore.label}}</div>
        </n-form-item>
        <n-form-item [label]="i18n.nameLab"
            [required]="true">
            <input id="create-windows-local-access-user-name"
                nInput
                type="text"
                formControlName="NAME"
                [placeholder]="nameTips[0] || ''"
                [nTooltip]="nameTip"
                [nTooltipTrigger]="'focus'"
                [nTooltipPlacement]="'top'"
                (blur)="onNameChange()">
            <input type="text" class="hidden">
        </n-form-item>
        <n-form-item [label]="i18n.passwordLab"
            [required]="true">
            <!-- 添加一个隐藏的输入框来欺骗firefox等浏览器的自动填充，离密码框要近 -->
            <input type="password" class="hidden">
            <input id="create-windows-local-access-user-password"
                nInput
                type="password"
                formControlName="PASSWORD"
                [placeholder]="passwordTips[0] || ''"
                [nTooltip]="passwordTip"
                [nTooltipTrigger]="'focus'"
                [nTooltipPlacement]="'top'">
        </n-form-item>
        <n-form-item [label]="i18n.confirmPasswordLab"
            [required]="true">
            <input id="create-windows-local-access-user-confirm-password"
                nInput
                type="password"
                formControlName="CONFIRMPASSWORD"
                [placeholder]="passwordTips[0] || ''"
                canPaste/>
        </n-form-item>
        <n-form-item  [label]="i18n.statusLab">
            <n-checkbox id="create-windows-local-access-user-status"
                formControlName="STATUSENABLE"
                [label]="i18n.enableBtn">
            </n-checkbox>
        </n-form-item>
        <n-form-item [label]="i18n.descriptionLab">
            <textarea id="create-windows-local-access-user-description"
                nTextarea
                formControlName="DESCRIPTION"
                [placeholder]="errorMessage.DESCRIPTION.rangeByteLength || ''">
            </textarea>
        </n-form-item>
        <n-form-item [label]="i18n.belongGroupLab">
            <n-advanced #groupToggle
                class="toggle"
                [expand]="true"
                [title]="selectedGroups.length">
            </n-advanced>
        </n-form-item>
        <n-form-item [class.hidden]="!groupToggle || !groupToggle.expand"
            [labelHide]="true">
            <n-transfer-table id="protection_lun_snapshot_create_lun"
                style="height: 350px;"
                [leftTitle]="i18n.leftGroupTitle"
                [rightTitle]="i18n.rightGroupTitle"
                [config]="groupTableConfig"
                [leftColumnDefs]="groupColumnDefs"
                [rest]="groupRest"
                [(selection)]="selectedGroups">
            </n-transfer-table>
        </n-form-item>
    </form>

    <ng-template #nameTip>
        <ul class="input-tips">
            <li *ngFor="let item of nameTips">{{item}}</li>
        </ul>
    </ng-template>
    <ng-template #passwordTip>
        <ul class="input-tips">
            <li *ngFor="let item of passwordTips">{{item}}</li>
        </ul>
    </ng-template>

    <n-footer>
        <button id="create-windows-local-access-user-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="create-windows-local-access-user-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
